import {
  Outlet,
  createFileRoute,
  notFound,
  redirect,
} from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import z from 'zod/v4'
import { getBookingQueryOptions } from '@/queries/query/booking'
import { queryKeys } from '@/queries/keys'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/make-booking/$id')({
  params: {
    parse: (params) => ({
      id: z.string().trim().parse(params.id),
    }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => {
    try {
      if (onlineManager.isOnline() && !context.isRestoring) {
        return await context.queryClient.ensureQueryData(
          getBookingQueryOptions(params.id),
        )
      }
      return context.queryClient.getQueryData(
        queryKeys.booking.detail(params.id),
      )
    } catch (error) {
      if (isHttpError(error, 401)) {
        if (!context.authContext.isAuthenticated)
          throw redirect({
            to: '/auth/login',
          })
        throw notFound()
      }
      if (isHttpError(error, 404)) {
        throw notFound()
      }
      throw error
    }
  },
  component: RouterComponent,
})

function RouterComponent() {
  return <Outlet />
}
